var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t11.4,14.7 0.8,14.8 0.8,1.3 11.4,1.3 \t","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15.2,8 11.1,6 11.2,8 11.1,10 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.1","y1":"8","x2":"4.3","y2":"8","key":2})]));
}

Logout.displayName = "Logout";

Logout.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Logout;

Logout.default = Logout;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/logout.svg
// module id = ../icon/src/icons/logout.svg
// module chunks = 0